<template>
  <JAccordionGroup
    :modelValue="activeIndex"
    :accordions="accordionItems"
    @update:model-value="setActiveIndex($event)"
    @cancel="activeIndex = -1"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { JAccordionGroup } from '@journey/ui-kit'
import { LOYALTY_MANAGE_POINTS_ACCORDION_ITEMS } from './LoyaltyManagePoints.constants'
import useManagePoints from '@/modules/Loyalty/composables/useManagePoints'

const { t } = useI18n()

const { activeIndex, setActiveIndex } = useManagePoints()

const accordionItems = LOYALTY_MANAGE_POINTS_ACCORDION_ITEMS.flatMap(
  ({ content, title }) => ({
    title: t(title),
    content,
    lazy: true,
  })
)
</script>
